import { createSelector } from 'reselect';

/**
 * @private
 * Retrieves the current app state of the machete.model tree
 * @param {Object} state - entire redux store
 * @returns {Object} current machete model in the redux store
 */
const getModel = (state) => state.machete.model;

/**
 * Retrieve the model's facade Opacity
 * @returns {Number} percentage of opacity of the model
 */
const getFacadeOpacity = createSelector(
  getModel,
  (model) => model.facadeOpacity,
);

export default {
  getFacadeOpacity,
};
